import { render, staticRenderFns } from "./culturalCreative.vue?vue&type=template&id=3d6e96fe&scoped=true"
import script from "./culturalCreative.vue?vue&type=script&setup=true&lang=js"
export * from "./culturalCreative.vue?vue&type=script&setup=true&lang=js"
import style0 from "./culturalCreative.vue?vue&type=style&index=0&id=3d6e96fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e96fe",
  null
  
)

export default component.exports